import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Button} from '@mui/material';
import { Typography } from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {Grid} from '@mui/material';
import {StringAttribute} from '../../../common/lib/types'
import * as request from "superagent";

type State = {
   ready: boolean;
   maxReached?: boolean;
   limit?: boolean;
};

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   handleSubscribe: ()=>void
   cancelSubscribe: ()=>void
}

const styles = (theme:Theme):StyleRules => ({

})

class ConfirmSubscriptionSetup extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {
            ready: false
        }
      }

   componentDidMount() {
        request.get("/api/portal-user-subscriptions/validations/subscription-limit").then((validationResp: request.Response)=>{
            if (validationResp.body.maxSubscriptions) {
                this.setState({
                    ready: true,
                    maxReached: true,
                    limit: validationResp.body.limit
                })
            } else {
                this.setState({ready: true})
            }
        }).catch((err)=>{
            console.error(err)
        })
    
    }
    componentWillUnmount() {
        
    }

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        const {ready , maxReached, limit} = this.state
        const { cancelSubscribe, handleSubscribe } = this.props

        if (!ready) {
            return null
        }

        if (maxReached) {
            return (
                  <Dialog
                    open={true}
                    onClose={cancelSubscribe}
                  >
                    <DialogTitle>Max Subscriptions Reached</DialogTitle>
                    <DialogContent>
                        <div>You have reached your maximum subcription count. You are limited to {limit} active subscriptions. Click <a style={{color: 'blue'}} href="/subscriptions/list">here</a> to manage your subscriptions.</div>
                    </DialogContent>
                    <DialogActions>
                     <Button
                        autoFocus={true}
                        onClick={cancelSubscribe}
                        variant="contained"
                        color="primary"
                    >
                        Cancel
                    </Button>
                    </DialogActions>
                  </Dialog>
            );
        } else {
            return (
                  <Dialog
                    open={true}
                    onClose={cancelSubscribe}
                  >
                    <DialogTitle>Create Email Subscription</DialogTitle>
                    <DialogContent>
                      <div>Would you like to create an email subscription?</div>
                      <br></br>
                      <div>You will be taken to the subscription setup page and guided through a short series of steps to configure your subscription.</div>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        variant="contained"
                        onClick={cancelSubscribe}
                        color="inherit"
                      >
                        No
                      </Button>
                      <Button
                        autoFocus={true}
                        onClick={handleSubscribe}
                        variant="contained"
                        color="primary"
                      >
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
            );
        }
      
    }
}

export default withStyles(styles)(ConfirmSubscriptionSetup);